import startOfMonth from "date-fns/start_of_month";
import endOfMonth from "date-fns/end_of_month";
import isAfter from "date-fns/is_after";
import isSameMonth from "date-fns/is_same_month";
import format from "date-fns/format";

const isNotAllowedDate = (date, today) => {
  if (isAfter(date, today) || isSameMonth(date, today)) return true;
  return false;
};

export const validateTenantsDates = ({ from, to }) => {
  const timeFormat = "T00:00:00";
  const selectedToDate = new Date(to + timeFormat);
  const selectedFromDate = new Date(from + timeFormat);
  const today = new Date();

  today.setDate(1);

  if (
    isNotAllowedDate(selectedFromDate, today) ||
    isNotAllowedDate(selectedToDate, today)
  ) {
    const errMessage = "Cannot select future or current month.";
    return { error: errMessage, queryParams: "" };
  }

  if (isAfter(selectedFromDate, selectedToDate)) {
    const errMessage = "Invalid date range: from date is after to date";
    return { error: errMessage, queryParams: "" };
  }

  const monthStart = format(startOfMonth(selectedToDate), "YYYY-MM-DD");
  const monthEnd = format(endOfMonth(selectedFromDate), "YYYY-MM-DD");

  const queryParams = `?from=${monthStart}&to=${monthEnd}`;
  return { queryParams, error: null };
};

const getDateData = ({ selectedDate, firstDay }) => {
  const selectedYear = selectedDate.getFullYear();
  const selectedMonth = selectedDate.getMonth();
  const defaultOptions = { year: selectedYear, month: selectedMonth, day: 1 };
  const options = firstDay
    ? defaultOptions
    : { ...defaultOptions, month: selectedMonth + 1, day: 0 };
  return new Date(options.year, options.month, options.day);
};

export const getFirstDayOfMonth = (selectedDate) => {
  return getDateData({ selectedDate, firstDay: true });
};

export const getLastDayOfMonth = (selectedDate) => {
  return getDateData({ selectedDate, firstDay: false });
};
